import { render, staticRenderFns } from "./billstoreceive.vue?vue&type=template&id=3d61621e&scoped=true&"
import script from "./billstoreceive.vue?vue&type=script&lang=js&"
export * from "./billstoreceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61621e",
  null
  
)

export default component.exports